export default __webpack_public_path__ + "static/media/Facebook.1832314e.svg";